import { Phone } from "lucide-react";
import { RESTAURANT } from "../data/restaurant";

export default function FloatingCallButton() {
  return (
    <a
      href={`tel:${RESTAURANT.phoneRaw}`}
      data-testid="floating-call-button"
      aria-label="Call Rivaaz to order"
      className="md:hidden fixed bottom-5 right-5 z-50 bg-[#C9853E] hover:bg-[#A6692D] text-white rounded-full w-14 h-14 flex items-center justify-center shadow-2xl shadow-[#C9853E]/40 active:scale-95 transition-transform"
    >
      <span className="absolute inset-0 rounded-full bg-[#C9853E] animate-ping opacity-20" />
      <Phone className="w-6 h-6 relative" />
    </a>
  );
}
